export const DEFAULT_PER_PAGE = 50
export const MAX_PER_PAGE = 200 // max allowed by apiv3 backend
export const DEFAULT_OFFSET = 0
// pagination utility
//
// given:
// - a promiseProducer function that takes the params {page, perPage} and
//   returns a promise
// - a perPage param
// - a isLastPage function that takes the perPage, current pageIndex, and the
//   results from the invocation of promiseProducer corresponding to pageIndex,
//   and returns a boolean indicating whether this is the last page of results
//
// it will return a function that will call promiseProducer with an incrementing
// page index until the condition defined in isLastPage is satisfied
export const loadAllPages = ({promiseProducer, perPage, isLastPage}) => {
  return new Promise((resolve, reject) => {
    const loadPage = (pageIndex) => {
      promiseProducer({pageIndex, perPage})
        .then(result => {
          if (isLastPage({perPage, pageIndex: pageIndex, pageResults: result})) {
            resolve()
          } else {
            loadPage(pageIndex + 1)
          }
        })
        .catch(reject)
    }
    loadPage(0)
  })
}
